import React from 'react'

import { IProps } from './index'
import { GridContainer } from 'marketing-site/src/mvp/library/components/GridContainer'

export const IconGrid: React.FC<IProps> = ({
  layout = '3-3',
  eyebrow,
  title,
  subhead,
  cta,
  items,
  backgroundColor,
}) => {
  return (
    <>
      <div className="icon-grid" data-testid="icon-grid">
        <GridContainer
          layout={layout}
          eyebrow={eyebrow}
          title={title}
          titleSize="heading-2"
          subhead={subhead}
          cta={cta}
          ctaPosition="below-header"
          body={items}
          bodyAlignment="start"
          bodyColumnGap="default"
          bodyRowGap="huge"
          backgroundColor={backgroundColor}
        />
      </div>

      <style jsx>{`
        .icon-grid {
          // prettier-ignore
          :global(.mvp-background-color-slate .icon-grid-item__subhead span,
            .mvp-background-color-blue .icon-grid-item__subhead span,
            .mvp-background-color-deep-teal .icon-grid-item__subhead span) {
            color: var(--paper);
          }
        }
      `}</style>
    </>
  )
}
